var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"linear-gradient(180deg,#35495e,#40b782)"}},[_c('nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }